import React, { Component, Fragment } from 'react';

class MatrixFalseTriggerTable extends Component {
    state = {
        devicesInHeader: null,
        falseTriggersRows: null
    }

    displayDeviceHeaders = uniqueDevices => {
        const devicesInHeader = Array.from(uniqueDevices).sort((a,b) => {
            if (a.name > b.name) return 1
            if (a.name < b.name) return -1
            return 0
        })

        // Update state only if devicesInHeaders are different from current state
        if (JSON.stringify(devicesInHeader) !== JSON.stringify(this.state.devicesInHeader)) {
            this.setState({devicesInHeader})
        }

        return devicesInHeader.map(device => <th key={device.name}>{device.name}</th>);
    };

    displayZones = (zones) => {
        const { devicesInHeader } = this.state

        const sortedZonesByName = zones.sort((a,b) => {
            if (a.name > b.name) return 1
            if (a.name < b.name) return -1
            return 0
        })


        const triggersGroupedByZone = sortedZonesByName.reduce((acc, zone) => {
            if (zone.zoneId in acc) {
                acc[zone.zoneId].push(zone)
            } else {
                acc[zone.zoneId] = [zone]
            }

            return acc
        }, {})

        
        // Fill and mark the devices with no false triggers to later display Zeros (0) in rows
        Object.keys(triggersGroupedByZone).forEach(zoneId => {
            devicesInHeader && devicesInHeader.forEach(device => {
                const found = triggersGroupedByZone[zoneId].some(trigger => device.identifier === trigger.deviceId)
                
                if (!found) {
                    triggersGroupedByZone[zoneId].push({ zoneId, deviceId: device.identifier, noFalseTriggers: true })
                }
            })
        })

        const falseTriggersCount = (zone) => zone.reduce((acc, {zoneId, deviceId, zoneName, noFalseTriggers}) => {
            if (deviceId in acc) {
                acc[deviceId][zoneId] = acc[deviceId][zoneId] + 1 || 0
                acc[deviceId].total += acc[deviceId][zoneId] ? 1 : 0
            } else if (noFalseTriggers) {
                acc[deviceId] = { [zoneId] : 0, total: 0, zoneId }
            } else {
                acc[deviceId] = { [zoneId] : 1, total: 1, zoneName, zoneId }
            }

            return acc
        }, {})
        
        const falseTriggersRows = Object.keys(triggersGroupedByZone).map(zoneId => {
            return falseTriggersCount(triggersGroupedByZone[zoneId])
        })

        if (JSON.stringify(falseTriggersRows) !== JSON.stringify(this.state.falseTriggersRows)) {
            this.setState({falseTriggersRows})
        }

        const sortedKeysByName =  devicesInHeader && devicesInHeader.sort((a,b) => {
            if (a.name > b.name) return 1
            if (a.name < b.name) return -1
            return 0
        }).map(device => device.identifier)

        return falseTriggersRows.map(groupByZone => {
            const firstDeviceId = Object.keys(groupByZone)[0]
            let eachRowCount = 0;
            const totalDevicesCount = devicesInHeader ? devicesInHeader.length : 0;

            return (
                <tr key={groupByZone[firstDeviceId].zoneName}>
                    <td>{groupByZone[firstDeviceId].zoneName || groupByZone[firstDeviceId].zoneId}</td>
                    { sortedKeysByName && sortedKeysByName.map(deviceId => {
                        eachRowCount += groupByZone[deviceId].total;
                        return <td>{groupByZone[deviceId].total}</td>})}
                    <td>{ ((eachRowCount/totalDevicesCount) * 100).toFixed(2) }</td>
                </tr>
            )
        })
    };

    displaySummary(zones) {
        const { triggers, devicesShowing } = this.props
        const { falseTriggersRows } = this.state

        const countTotalFalsePerDevice = zones && Array.from(zones).reduce((acc, zone) => {
            if (zone.deviceId in acc) {
                acc[zone.deviceId] += 1
            } else {
                acc[zone.deviceId] = 1
            }

            return acc
        }, {})

        const groupTriggersByDeviceId = falseTriggersRows && triggers.reduce((acc, { deviceId }) => {
            if (!(deviceId in acc)) {
                const deviceFound = devicesShowing.find(device => device.identifier === deviceId)
                const falseTriggers = countTotalFalsePerDevice[deviceId] || 0
                if (deviceFound) {
                    acc[deviceId] = {
                        total: 1,
                        name: deviceFound.name,
                        falseTriggers,
                        deviceId
                    }
                }
            } else {
                acc[deviceId].total += 1
            }

            return acc
        }, {})

        const sortedKeys = groupTriggersByDeviceId && Object.keys(groupTriggersByDeviceId).sort((a,b) => {
            if (groupTriggersByDeviceId[a].name > groupTriggersByDeviceId[b].name) return 1
            if (groupTriggersByDeviceId[a].name < groupTriggersByDeviceId[b].name) return -1
            return 0
        })

        let totalPercentage = 0;

        return (
            <Fragment>
                <tr>
                    <td>Total</td>
                    { groupTriggersByDeviceId && sortedKeys.map(key => <td>{ groupTriggersByDeviceId[key].falseTriggers }</td>)}
                    <td>{ "--" }</td>
                </tr>
                <tr>
                    <td>Percentage</td>
                    { groupTriggersByDeviceId && sortedKeys.map(key =>{
                        const eachDevicePercentage = ((groupTriggersByDeviceId[key].falseTriggers / groupTriggersByDeviceId[key].total) * 100).toFixed(2)
                        totalPercentage += parseFloat(eachDevicePercentage);

                        return (<td>{eachDevicePercentage}</td>)})}
                    <td>{ sortedKeys ? (totalPercentage/sortedKeys.length).toFixed(2) : 0 }</td>
                </tr>
            </Fragment>
        )
    }

    render() {
        const { zones, triggers, devicesShowing, readTriggersDataFromLogs } = this.props;
        let uniqueDevices = new Set();
        let zonesWithFalseTriggers = [];

        // Check for false triggers and create a list of unique Zones and Devices
        triggers.forEach(trigger => {
            let zoneExists = true;

            zones.forEach(zone => {
                if (zone._id === trigger.zoneId) {
                    zoneExists = false;
                }
            });

            if (zoneExists) {
                zonesWithFalseTriggers.push(trigger);
            }

            const deviceWithFalseTrigger = devicesShowing.find(device => trigger.deviceId === device.identifier);

            if (deviceWithFalseTrigger) uniqueDevices.add(deviceWithFalseTrigger);
        });

        return (
            <Fragment>
                { (zonesWithFalseTriggers.length && uniqueDevices.size) ? (
                    <div className="matrix-analysis-main-div wide-view">
                        <h4 className="text-center">False Triggers</h4>
                        <div className="matrix-analysis">
                        <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th> {readTriggersDataFromLogs ? "Zone Id" : "Zone Name"}</th>
                                        {uniqueDevices && this.displayDeviceHeaders(uniqueDevices)}
                                        <th>Percentage</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {uniqueDevices && this.displayZones(zonesWithFalseTriggers, uniqueDevices)}
                                    {uniqueDevices && this.displaySummary(zonesWithFalseTriggers, uniqueDevices)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : null }
            </Fragment>
        );
    }
}

export default MatrixFalseTriggerTable;
